<template>
<div class="pagetitle">
  <h1>Профиль</h1>
  <nav>
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><router-link to="/">Домой</router-link></li>
      <li class="breadcrumb-item active">Профиль</li>
    </ol>
  </nav>
</div>

<section class="section profile">
  <div class="row">
    <div class="col-xl-12">

      <div class="card">
        <div class="card-body pt-3">
          <!-- Bordered Tabs -->
          <ul class="nav nav-tabs nav-tabs-bordered">

            <li class="nav-item">
              <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#profile-overview">Уведомления</button>
            </li>

            <li class="nav-item">
              <button class="nav-link" data-bs-toggle="tab" data-bs-target="#profile-edit">Профиль</button>
            </li>

            <li class="nav-item">
              <button class="nav-link" data-bs-toggle="tab" data-bs-target="#profile-change-password">Смена пароля</button>
            </li>

          </ul>
          <div class="tab-content pt-2">

            <div class="tab-pane fade show active profile-overview" id="profile-overview">
              <h5 class="card-title">Уведомления</h5>
              <NotificationsTable />
            </div>

            <div class="tab-pane fade profile-edit pt-3" id="profile-edit">
              <UserInfoForm />
            </div>

            <div class="tab-pane fade pt-3" id="profile-change-password">
              <UserChangePassword />
            </div>

          </div>

        </div>
      </div>

    </div>
  </div>
</section>
</template>

<script>
import NotificationsTable from "@/features/notifications/components/NotificationsTable.vue";
import UserInfoForm from "@/features/personal/components/UserInfoForm.vue";
import UserChangePassword from "@/features/personal/components/UserChangePassword.vue";

export default {
  name: "PersonalPage",
  components: {UserChangePassword, UserInfoForm, NotificationsTable}
}
</script>

<style scoped>

</style>